export class PostContactFormReducer {
    reduce = (result) => ({
        body: result.body
    });
}
